<template>
  <div>
    <!-- start note edit box -->
    <v-dialog
      v-model="dialog"
      max-width="500px"
    >
      <v-card>
        <v-card-title>
          <span class="headline">Edit</span>
        </v-card-title>

        <v-card-text>
          <!-- textArea -->
          <v-textarea
            v-model="editedItem.note"
            label="Note"
            outline
          />
        </v-card-text>

        <v-card-actions>
          <v-spacer/>
          <v-btn
            color="blue darken-1"
            flat
            @click.native="close"
          >
            Cancel
          </v-btn>
          <v-btn
            color="blue darken-1"
            flat
            @click.native="save"
          >
            Save
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!-- end note edit box -->
    <!-- start actions -->
    <v-layout
      v-if="editPermission"
      row
    >
      <!--action dropdown-->
      <v-select
        v-model="dropdown.action"
        :disabled="!dropdownEnabled"
        :items="dropdownItems"
        item-value="value"
        item-test="text"
        label="Choose Action"
        solo
      />
      <!-- only show if cancel or cancelTocart is slected-->
      <v-select
        v-if="dropdown.action == 'cancel' || dropdown.action == 'cancelToCart'"
        v-model="dropdown.confirmCancel"
        :disabled="!dropdownEnabled"
        :items="confirmationMenu"
        item-value="value"
        item-test="text"
        label="Are You sure?"
        solo
      />
      <!-- only show if changeParties is selected-->
      <template v-if="dropdown.action == 'changeParties'">
        <v-text-field
          v-model="dropdown.changeParties.adult"
          :disabled="!dropdownEnabled"
          mask="##"
          label="Adult"
          solo
        />
        <v-text-field
          v-model="dropdown.changeParties.junior"
          :disabled="!dropdownEnabled"
          mask="##"
          label="Junior"
          solo
        />
        <v-text-field
          v-model="dropdown.changeParties.child"
          :disabled="!dropdownEnabled"
          mask="##"
          label="Child"
          solo
        />
      </template>
      <!-- only show if any action is selected -->
      <v-btn
        v-if="String(dropdown.action) != 'false'"
        @click="performAction()"
      >
        Apply
      </v-btn>
    </v-layout>
    <!-- end actions -->
    <!-- start itineraries -->
    <v-alert
      :value="!itineraries.length && !loading"
      type="info"
    >
      No Results
    </v-alert>
    <v-progress-linear
      v-if="loading"
      :indeterminate="true"
    />
    <v-expansion-panel
      v-max-height="{height: '50vh'}"
    >
      <v-expansion-panel-content
        v-for="(itinerary, index) in itineraries"
        :key="itinerary.itineraryID"
        :hide-actions="!editPermission"
        :readonly="!editPermission"
        class="py-4 ma-1 elevation-5"
        lazy
        @input="getCampsiteBookings({itineraryID: itinerary.itineraryID})"
      >
        <!-- start header -->
        <div
          slot="header"
          :class="editPermission ? '' : 'not-clickable'"
          class="my-5"
        >
          <v-layout
            row
            align-center
          >
            <v-flex xs4>
              <strong>ID:</strong> {{ itinerary.itineraryID }}<br>
              {{ itinerary.startDate }}<br>
              {{ itinerary.endDate }}
            </v-flex>
            <v-flex xs4>
              <v-layout justify-center>
                <IconButton
                  :to="'/print/itinerary/' + itinerary.itineraryID"
                  tooltip="View"
                  color="indigo"
                  icon="fa-print"
                />
                <template v-if="editPermission">
                  <IconButton
                    v-if="editPermission"
                    tooltip="Note"
                    icon="fa-comment-alt"
                    color="pink"
                    @click="editItem(itinerary)"
                  />
                  <IconButton
                    v-if="selectedCampsiteBookings.length"
                    icon="fas fa-compress-arrows-alt"
                    tooltip="Move selected to this itinerary"
                    color="orange"
                    @click="moveTo(itinerary.itineraryID)"
                  />
                </template>
              </v-layout>
              <v-layout
                v-if="editPermission"
                justify-center
                align-center
              >
                <IconButton
                  tooltip="Subtract Gate Pass"
                  icon="fa-minus-square"
                  @click="updateGatePassUnassign({itineraryID: itinerary.itineraryID})"
                />
                {{ itinerary.gatePasses }}
                <IconButton
                  tooltip="Add Gate Pass"
                  icon="fa-plus-square"
                  @click="updateGatePassAssign({itineraryID: itinerary.itineraryID})"
                />
              </v-layout>
            </v-flex>
            <v-flex
              xs1
              offset-xs4
              @click.stop=""
            >
              <v-checkbox
                v-if="editPermission"
                :value="itineraryCheckboxState(index)"
                :indeterminate="itineraryCheckboxState(index) === 'indeterminate'"
                type="checkbox"
                class="pl-3"
                @click="checkAll(index)"
              />
            </v-flex>
          </v-layout>
        </div>
        <!-- end header -->
        <v-divider class="mt-4"/>
        <!-- start campsiteBookings -->
        <div>
          <campsite-bookings
            v-for="campsiteBooking in itinerary.campsiteBookings"
            :key="campsiteBooking.campsiteBookingID"
            :campsite-booking="campsiteBooking"
            show-details
          >
            <!-- start actions -->
            <template
              v-if="editPermission"
              slot="actions"
            >
              <v-checkbox
                :value="campsiteBooking.campsiteBookingID"
                v-model="selectedCampsiteBookings"
                type="checkbox"
                class="text-xs-right"
              />
            </template>
            <!-- end actions -->
            <!-- start additional content -->
            <template>
              Adult: {{ campsiteBooking.adult }}<br>
              Junior: {{ campsiteBooking.junior }}<br>
              Child: {{ campsiteBooking.child }}
            </template>
            <!-- end content -->
          </campsite-Bookings>
          <!-- end campsiteBoookings -->
        </div>
      </v-expansion-panel-content>
      <v-btn
        flat
        color="primary"
        @click="showOlder=!showOlder"
      >
        <template v-if="showOlder">
          Hide Older
        </template>
        <template v-else>
          Show Older
        </template>
      </v-btn>
    </v-expansion-panel>
    <!-- end itineraries -->
  </div>
</template>

<script>
// import components
import { mapGetters, mapActions } from 'vuex'

export default {
  data () {
    return {
      showOlder: false,
      date: this.$moment(),
      loading: true,
      dialog: false,
      editedIndex: -1,
      editedItem: {
        note: ''
      },
      dropdownItems: [
        {
          value: 'moveToNew',
          text: 'Move to New Itinerary'
        },
        {
          value: 'changeParties',
          text: 'Change Parties'
        },
        {
          value: 'cancel',
          text: 'Cancel'
        },
        {
          value: 'cancelToCart',
          text: 'Cancel to Cart'
        }
      ],
      confirmationMenu: [
        {
          value: false,
          text: 'No'
        },
        {
          value: true,
          text: 'Yes'
        }
      ],
      dropdown: {
        action: false,
        confirmCancel: null,
        changeParties: {
          adult: null,
          junior: null,
          child: null
        }
      },
      selectedCampsiteBookings: []
    }
  },
  computed: {
    dropdownEnabled () {
      return Boolean(this.selectedCampsiteBookings.length)
    },
    ...mapGetters({
      $itineraries: 'itineraries/itineraries'
    }),
    editPermission () {
      return this.assertSetting('editReservations', 1)
    },
    itineraries () {
      if (!this.showOlder) {
        return this.$itineraries.filter((itinerary) => {
          let currentDate = this.$moment()
          let endDate = this.$moment(itinerary.endDate)
          return endDate.isSameOrAfter(currentDate, 'day')
        })
      }
      return this.$itineraries
    }
  },
  mounted () {
    this.getItineraries().then(() => {
      this.loading = false
    })
  },
  methods: {
    ...mapActions({
      getItineraries: 'itineraries/getItineraries',
      getCampsiteBookings: 'itineraries/getCampsiteBookings',
      deleteItineraries: 'itineraries/deleteItineraries',
      deleteCampsiteBookings: 'itineraries/deleteCampsiteBookings',
      updateCampsiteBookingParties: 'itineraries/updateCampsiteBookingParties',
      updateCampsiteBookingItinerary: 'itineraries/updateCampsiteBookingItinerary',
      getBaxterBucks: 'person/getBaxterBucks',
      updateItinerary: 'itineraries/updateItinerary',
      getGatePasses: 'passes/getGatePasses',
      updateGatePassAssign: 'passes/updateGatePassAssign',
      updateGatePassUnassign: 'passes/updateGatePassUnassign',
      getCart: 'cart/getCart'
    }),
    checkAll (itineraryIndex) {
      let currentState = this.itineraryCheckboxState(itineraryIndex)
      // get the bookings first just in case
      this.getCampsiteBookings({ itineraryID: this.itineraries[itineraryIndex].itineraryID }).then(() => {
        // associated ids
        let campsiteBookingIDs = this.itineraries[itineraryIndex].campsiteBookings.map(booking => booking.campsiteBookingID)
        // if unchecked check all, otherwise uncheck all
        if (!currentState) {
          this.selectedCampsiteBookings = [...new Set([...this.selectedCampsiteBookings, ...campsiteBookingIDs])]
        } else {
          this.selectedCampsiteBookings = this.selectedCampsiteBookings.filter(element => !campsiteBookingIDs.includes(element))
        }
      })
    },
    refresh () {
      this.loading = true
      // reload gate gatePasses
      this.getGatePasses()
      // reload campsite bookings for all itineraries that have them loaded in the state
      this.itineraries.forEach((itinerary) => {
        if (itinerary.campsiteBookings) {
          this.getCampsiteBookings({ itineraryID: itinerary.itineraryID })
        }
      })
      this.getItineraries().then(() => {
        this.loading = false
      })
      // reset component data
      Object.assign(this.$data, this.$options.data.apply(this))
      // reload baxter bucks in case anything changed
      this.getBaxterBucks()
    },
    itineraryCheckboxState (itineraryIndex) {
      /* if all bookings are checked, check
      if some bookings are checked line
      if no bookings are checked, no check */
      if (this.itineraries[itineraryIndex].campsiteBookings) {
        let campsiteBookingIDs = this.itineraries[itineraryIndex].campsiteBookings.map(booking => booking.campsiteBookingID).sort()
        let matches = this.selectedCampsiteBookings.filter(element => campsiteBookingIDs.includes(element)).sort()
        if (matches.length === campsiteBookingIDs.length) {
          // everything is checked
          return true
        } else if (matches.length > 0) {
          return 'indeterminate'
        } else {
          return false
        }
      } else {
        return false
      }
    },
    performAction () {
      switch (this.dropdown.action) {
        case 'moveToNew':
          this.moveTo(null)
          break
        case 'cancel':
          this.cancelReservations()
          break
        case 'cancelToCart':
          this.cancelToCart()
          break
        case 'changeParties':
          this.changeParties()
          break
        default:
          console.log('no action selected')
      }
    },
    cancelReservations () { // cancel the selected reservations
      if (!this.dropdown.confirmCancel) { // confirmation dropdown must be yes
        return
      }
      // delete getCampsiteBookings
      this.deleteCampsiteBookings({ campsiteBookingIDs: this.selectedCampsiteBookings }).then(this.refresh)
    },
    cancelToCart () { // cancel the selected reservations and rebook them.
      if (this.dropdown.confirmCancel) { // confirmation dropdown must be yes
        // delete getCampsiteBookings
        this.deleteCampsiteBookings({ campsiteBookingIDs: this.selectedCampsiteBookings, toCart: true }).then(this.refresh).then(this.getCart)
      }
    },
    changeParties () { // modifies the party for selected reservations
      let payload = {
        campsiteBookingIDs: this.selectedCampsiteBookings,
        adult: this.dropdown.changeParties.adult,
        junior: this.dropdown.changeParties.junior,
        child: this.dropdown.changeParties.child
      }
      this.updateCampsiteBookingParties(payload).then(this.refresh)
    },
    moveTo (itineraryID) {
      let payload = {
        campsiteBookingIDs: this.selectedCampsiteBookings,
        itineraryID: itineraryID
      }
      this.updateCampsiteBookingItinerary(payload).then(this.refresh)
    },
    editItem (item) {
      this.editedIndex = this.itineraries.indexOf(item)
      this.editedItem = Object.assign({}, item)
      this.dialog = true
    },
    close () {
      this.dialog = false
      setTimeout(() => {
        this.editedItem = Object.assign({}, this.defaultItem)
        this.editedIndex = -1
      }, 300)
    },
    save () {
      this.itineraries[this.editedIndex].note = this.editedItem.note
      this.updateItinerary(this.itineraries[this.editedIndex])
      this.close()
    }
  }
}
</script>
